import CustomerDetail1BackOriginScrollTopMixins from "@/mixins/CustomerDetail1BackOriginScrollTop";

export default {
    mixins: [CustomerDetail1BackOriginScrollTopMixins],
    props: [
        "isLoading",
        "isAllLoading",
        "allFamilyDatas",
        "getCathayInsuranceResult",
        "getOtherInsuranceResult",
        "getGroupInsuranceResult",
        // "getCustInsurance_CCIPLN4MVResult",
        // "getCustInsurance_CCIPLN2MVResult",
        // "getCustInsurance_CCIPLN1MVResult",
        // "getCustInsurance_CCIPLC1MVResult",
        // "getCustInsurance_CCIPLF1MVResult",
        // "getOtherPropertyInsuranceResult"
    ],
    components: {
        CathayLifeInsurance: () =>
            import ("./components/CathayLifeInsurance"),
        CathayLifeInsuranceForEdit: () =>
            import ("./components/CathayLifeInsuranceForEdit"),
        OtherLifeInsurance: () =>
            import ("./components/OtherLifeInsurance"),
        OtherLifeInsuranceForEdit: () =>
            import ("./components/OtherLifeInsuranceForEdit"),
        ProductSuggest: () =>
            import ("./components/ProductSuggest"),
        ProductSuggestForEdit: () =>
            import ("./components/ProductSuggestForEdit"),
        CathayGroupInsurance: () =>
            import ("./components/CathayGroupInsurance"),
        // CathayPropertyHealthInsurance: () =>
        //     import ("./components/CathayPropertyHealthInsurance"),
        // CathayPropertyHurtInsurance: () =>
        //     import ("./components/CathayPropertyHurtInsurance"),
        // CathayPropertyNewInsurance: () =>
        //     import ("./components/CathayPropertyNewInsurance"),
        // OtherPropertyNewInsurance: () =>
        //     import ("./components/OtherPropertyNewInsurance"),
        // CathayPropertyCarInsurance: () =>
        //     import ("./components/CathayPropertyCarInsurance"),
        // CathayPropertyFireInsurance: () =>
        //     import ("./components/CathayPropertyFireInsurance"),
        // OtherPropertyCarInsurance: () =>
        //     import ("./components/OtherPropertyCarInsurance"),
        // OtherPropertyFireInsurance: () =>
        //     import ("./components/OtherPropertyFireInsurance"),
        Message: () =>
            import ("./components/Message")
    },
    methods: {
        // assignFamilyInfo(datas) {
        //     return datas.filter(x => x).map((data) => {
        //         const { ceisdno, CEISDNO } = data;
        //         const targetProp = ceisdno || CEISDNO;
        //         //查詢家戶取家戶成員的排序,年齡
        //         if (this.familyKeyBuCsidno[targetProp]) {
        //             data.familyorder = this.familyKeyBuCsidno[targetProp].familyorder;
        //             data.familyrl = this.familyKeyBuCsidno[targetProp].familyrl;
        //             data.age = this.familyKeyBuCsidno[targetProp].age;
        //             data.ceisdnoorder = this.familyKeyBuCsidno[targetProp].csidno.replace(/~/, '');
        //         }
        //         //經手收費保單（body.policies）與 自行輸入保單（body.policiesselfinput）排序使用
        //         data.orderbBySelf = data.isKeyinBySelf ? 1 : 0;
        //         return data;
        //     });
        // },
        //是否為自行輸入保單
        // assignKeyinBySelf(datas) {
        //     return datas ? datas.map((x) => ((x.isKeyinBySelf = true), x)) : [];
        // },
        panelOpen(name) {
            this[name] = true;
            document.querySelector('body').classList.add('modal-open');
          },
        panelClose(name) {
            return new Promise(resolve => {
                var open = document.querySelectorAll('.modal.is-open'),
                elem = open[open.length - 1];
                elem.className += ' is-out';
                elem.classList.remove('is-out');
                if (open.length >= 1) {
                document.querySelector('body').classList.remove('modal-open');
                }
                this[name] = false;
            });
        },
    },
    computed: {
        familyKeyBuCsidno() {
            return window._.keyBy(this.allFamilyDatas, "csidno");
        },
        lifeInsuranceList() {
            return [this.getCathayInsuranceResult]
                .concat(
                    this.getOtherInsuranceResult ? [
                        this.getOtherInsuranceResult.suggestinfo,
                        this.getOtherInsuranceResult.otherinfo
                    ] : []
                )
                .filter((x) => x);
        },
        groupInsuranceList() {
            return [this.getGroupInsuranceResult].filter((x) => x);
        },
        // propertyInsuranceList() {
        //     return [
        //             this.getCustInsurance_CCIPLN4MVResult,
        //             this.getCustInsurance_CCIPLN2MVResult,
        //             this.getCustInsurance_CCIPLN1MVResult,
        //             this.getCustInsurance_CCIPLC1MVResult,
        //             this.getCustInsurance_CCIPLF1MVResult
        //         ]
        //         .map((x) => [].concat(x.policies ? x.policies : [], x.policiesselfinput ? x.policiesselfinput : []))
        //         .concat(
        //             this.getOtherPropertyInsuranceResult ? [
        //                 this.getOtherPropertyInsuranceResult.othermotordataset,
        //                 this.getOtherPropertyInsuranceResult.otherfiredataset,
        //                 this.getOtherPropertyInsuranceResult.othernewdataset
        //             ] : []
        //         )
        //         .filter((x) => x);
        // },
        allDataList() {
            return this.lifeInsuranceList.concat(
                this.groupInsuranceList,
                // this.propertyInsuranceList
            );
        },
        isLifeInsuranceHasData() {
            return this.lifeInsuranceList.some((x) => x.length);
        },
        isGroupInsuranceHasData() {
            return this.groupInsuranceList.some((x) => x.length);
        },
        // isPropertyInsuranceHasData() {
        //     return this.propertyInsuranceList.some((x) => x.length);
        // },
        hasData() {
            return this.allDataList.some((x) => x.length);
        }
    }
};